/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as pavilionPavilionRouteImport } from './routes/(pavilion)/pavilion'
import { Route as codegenCodegenRouteImport } from './routes/(codegen)/codegen'
import { Route as authWaitinglistRouteImport } from './routes/(auth)/waitinglist'
import { Route as authAuthRouteImport } from './routes/(auth)/auth'
import { Route as pavilionPavilionIndexRouteImport } from './routes/(pavilion)/pavilion.index'
import { Route as codegenCodegenIndexRouteImport } from './routes/(codegen)/codegen.index'
import { Route as authWaitinglistIndexRouteImport } from './routes/(auth)/waitinglist.index'
import { Route as authAuthIndexRouteImport } from './routes/(auth)/auth.index'
import { Route as pavilionPavilionNewRouteImport } from './routes/(pavilion)/pavilion/new'
import { Route as pavilionPavilionAgentNameRouteImport } from './routes/(pavilion)/pavilion/$agentName'
import { Route as codegenCodegenChatIdRouteImport } from './routes/(codegen)/codegen/$chatId'
import { Route as codegenCodegenChatIdAttachmentsVersionNumberRouteImport } from './routes/(codegen)/codegen/$chatId/attachments/$versionNumber'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const pavilionPavilionRoute = pavilionPavilionRouteImport.update({
  id: '/(pavilion)/pavilion',
  path: '/pavilion',
  getParentRoute: () => rootRouteImport,
} as any)
const codegenCodegenRoute = codegenCodegenRouteImport.update({
  id: '/(codegen)/codegen',
  path: '/codegen',
  getParentRoute: () => rootRouteImport,
} as any)
const authWaitinglistRoute = authWaitinglistRouteImport.update({
  id: '/(auth)/waitinglist',
  path: '/waitinglist',
  getParentRoute: () => rootRouteImport,
} as any)
const authAuthRoute = authAuthRouteImport.update({
  id: '/(auth)/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const pavilionPavilionIndexRoute = pavilionPavilionIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => pavilionPavilionRoute,
} as any)
const codegenCodegenIndexRoute = codegenCodegenIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => codegenCodegenRoute,
} as any)
const authWaitinglistIndexRoute = authWaitinglistIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => authWaitinglistRoute,
} as any)
const authAuthIndexRoute = authAuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => authAuthRoute,
} as any)
const pavilionPavilionNewRoute = pavilionPavilionNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => pavilionPavilionRoute,
} as any)
const pavilionPavilionAgentNameRoute =
  pavilionPavilionAgentNameRouteImport.update({
    id: '/$agentName',
    path: '/$agentName',
    getParentRoute: () => pavilionPavilionRoute,
  } as any)
const codegenCodegenChatIdRoute = codegenCodegenChatIdRouteImport.update({
  id: '/$chatId',
  path: '/$chatId',
  getParentRoute: () => codegenCodegenRoute,
} as any)
const codegenCodegenChatIdAttachmentsVersionNumberRoute =
  codegenCodegenChatIdAttachmentsVersionNumberRouteImport.update({
    id: '/attachments/$versionNumber',
    path: '/attachments/$versionNumber',
    getParentRoute: () => codegenCodegenChatIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof authAuthRouteWithChildren
  '/waitinglist': typeof authWaitinglistRouteWithChildren
  '/codegen': typeof codegenCodegenRouteWithChildren
  '/pavilion': typeof pavilionPavilionRouteWithChildren
  '/codegen/$chatId': typeof codegenCodegenChatIdRouteWithChildren
  '/pavilion/$agentName': typeof pavilionPavilionAgentNameRoute
  '/pavilion/new': typeof pavilionPavilionNewRoute
  '/auth/': typeof authAuthIndexRoute
  '/waitinglist/': typeof authWaitinglistIndexRoute
  '/codegen/': typeof codegenCodegenIndexRoute
  '/pavilion/': typeof pavilionPavilionIndexRoute
  '/codegen/$chatId/attachments/$versionNumber': typeof codegenCodegenChatIdAttachmentsVersionNumberRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/codegen/$chatId': typeof codegenCodegenChatIdRouteWithChildren
  '/pavilion/$agentName': typeof pavilionPavilionAgentNameRoute
  '/pavilion/new': typeof pavilionPavilionNewRoute
  '/auth': typeof authAuthIndexRoute
  '/waitinglist': typeof authWaitinglistIndexRoute
  '/codegen': typeof codegenCodegenIndexRoute
  '/pavilion': typeof pavilionPavilionIndexRoute
  '/codegen/$chatId/attachments/$versionNumber': typeof codegenCodegenChatIdAttachmentsVersionNumberRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(auth)/auth': typeof authAuthRouteWithChildren
  '/(auth)/waitinglist': typeof authWaitinglistRouteWithChildren
  '/(codegen)/codegen': typeof codegenCodegenRouteWithChildren
  '/(pavilion)/pavilion': typeof pavilionPavilionRouteWithChildren
  '/(codegen)/codegen/$chatId': typeof codegenCodegenChatIdRouteWithChildren
  '/(pavilion)/pavilion/$agentName': typeof pavilionPavilionAgentNameRoute
  '/(pavilion)/pavilion/new': typeof pavilionPavilionNewRoute
  '/(auth)/auth/': typeof authAuthIndexRoute
  '/(auth)/waitinglist/': typeof authWaitinglistIndexRoute
  '/(codegen)/codegen/': typeof codegenCodegenIndexRoute
  '/(pavilion)/pavilion/': typeof pavilionPavilionIndexRoute
  '/(codegen)/codegen/$chatId/attachments/$versionNumber': typeof codegenCodegenChatIdAttachmentsVersionNumberRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/waitinglist'
    | '/codegen'
    | '/pavilion'
    | '/codegen/$chatId'
    | '/pavilion/$agentName'
    | '/pavilion/new'
    | '/auth/'
    | '/waitinglist/'
    | '/codegen/'
    | '/pavilion/'
    | '/codegen/$chatId/attachments/$versionNumber'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/codegen/$chatId'
    | '/pavilion/$agentName'
    | '/pavilion/new'
    | '/auth'
    | '/waitinglist'
    | '/codegen'
    | '/pavilion'
    | '/codegen/$chatId/attachments/$versionNumber'
  id:
    | '__root__'
    | '/'
    | '/(auth)/auth'
    | '/(auth)/waitinglist'
    | '/(codegen)/codegen'
    | '/(pavilion)/pavilion'
    | '/(codegen)/codegen/$chatId'
    | '/(pavilion)/pavilion/$agentName'
    | '/(pavilion)/pavilion/new'
    | '/(auth)/auth/'
    | '/(auth)/waitinglist/'
    | '/(codegen)/codegen/'
    | '/(pavilion)/pavilion/'
    | '/(codegen)/codegen/$chatId/attachments/$versionNumber'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  authAuthRoute: typeof authAuthRouteWithChildren
  authWaitinglistRoute: typeof authWaitinglistRouteWithChildren
  codegenCodegenRoute: typeof codegenCodegenRouteWithChildren
  pavilionPavilionRoute: typeof pavilionPavilionRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(pavilion)/pavilion': {
      id: '/(pavilion)/pavilion'
      path: '/pavilion'
      fullPath: '/pavilion'
      preLoaderRoute: typeof pavilionPavilionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(codegen)/codegen': {
      id: '/(codegen)/codegen'
      path: '/codegen'
      fullPath: '/codegen'
      preLoaderRoute: typeof codegenCodegenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/waitinglist': {
      id: '/(auth)/waitinglist'
      path: '/waitinglist'
      fullPath: '/waitinglist'
      preLoaderRoute: typeof authWaitinglistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/auth': {
      id: '/(auth)/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof authAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(pavilion)/pavilion/': {
      id: '/(pavilion)/pavilion/'
      path: '/'
      fullPath: '/pavilion/'
      preLoaderRoute: typeof pavilionPavilionIndexRouteImport
      parentRoute: typeof pavilionPavilionRoute
    }
    '/(codegen)/codegen/': {
      id: '/(codegen)/codegen/'
      path: '/'
      fullPath: '/codegen/'
      preLoaderRoute: typeof codegenCodegenIndexRouteImport
      parentRoute: typeof codegenCodegenRoute
    }
    '/(auth)/waitinglist/': {
      id: '/(auth)/waitinglist/'
      path: '/'
      fullPath: '/waitinglist/'
      preLoaderRoute: typeof authWaitinglistIndexRouteImport
      parentRoute: typeof authWaitinglistRoute
    }
    '/(auth)/auth/': {
      id: '/(auth)/auth/'
      path: '/'
      fullPath: '/auth/'
      preLoaderRoute: typeof authAuthIndexRouteImport
      parentRoute: typeof authAuthRoute
    }
    '/(pavilion)/pavilion/new': {
      id: '/(pavilion)/pavilion/new'
      path: '/new'
      fullPath: '/pavilion/new'
      preLoaderRoute: typeof pavilionPavilionNewRouteImport
      parentRoute: typeof pavilionPavilionRoute
    }
    '/(pavilion)/pavilion/$agentName': {
      id: '/(pavilion)/pavilion/$agentName'
      path: '/$agentName'
      fullPath: '/pavilion/$agentName'
      preLoaderRoute: typeof pavilionPavilionAgentNameRouteImport
      parentRoute: typeof pavilionPavilionRoute
    }
    '/(codegen)/codegen/$chatId': {
      id: '/(codegen)/codegen/$chatId'
      path: '/$chatId'
      fullPath: '/codegen/$chatId'
      preLoaderRoute: typeof codegenCodegenChatIdRouteImport
      parentRoute: typeof codegenCodegenRoute
    }
    '/(codegen)/codegen/$chatId/attachments/$versionNumber': {
      id: '/(codegen)/codegen/$chatId/attachments/$versionNumber'
      path: '/attachments/$versionNumber'
      fullPath: '/codegen/$chatId/attachments/$versionNumber'
      preLoaderRoute: typeof codegenCodegenChatIdAttachmentsVersionNumberRouteImport
      parentRoute: typeof codegenCodegenChatIdRoute
    }
  }
}

interface authAuthRouteChildren {
  authAuthIndexRoute: typeof authAuthIndexRoute
}

const authAuthRouteChildren: authAuthRouteChildren = {
  authAuthIndexRoute: authAuthIndexRoute,
}

const authAuthRouteWithChildren = authAuthRoute._addFileChildren(
  authAuthRouteChildren,
)

interface authWaitinglistRouteChildren {
  authWaitinglistIndexRoute: typeof authWaitinglistIndexRoute
}

const authWaitinglistRouteChildren: authWaitinglistRouteChildren = {
  authWaitinglistIndexRoute: authWaitinglistIndexRoute,
}

const authWaitinglistRouteWithChildren = authWaitinglistRoute._addFileChildren(
  authWaitinglistRouteChildren,
)

interface codegenCodegenChatIdRouteChildren {
  codegenCodegenChatIdAttachmentsVersionNumberRoute: typeof codegenCodegenChatIdAttachmentsVersionNumberRoute
}

const codegenCodegenChatIdRouteChildren: codegenCodegenChatIdRouteChildren = {
  codegenCodegenChatIdAttachmentsVersionNumberRoute:
    codegenCodegenChatIdAttachmentsVersionNumberRoute,
}

const codegenCodegenChatIdRouteWithChildren =
  codegenCodegenChatIdRoute._addFileChildren(codegenCodegenChatIdRouteChildren)

interface codegenCodegenRouteChildren {
  codegenCodegenChatIdRoute: typeof codegenCodegenChatIdRouteWithChildren
  codegenCodegenIndexRoute: typeof codegenCodegenIndexRoute
}

const codegenCodegenRouteChildren: codegenCodegenRouteChildren = {
  codegenCodegenChatIdRoute: codegenCodegenChatIdRouteWithChildren,
  codegenCodegenIndexRoute: codegenCodegenIndexRoute,
}

const codegenCodegenRouteWithChildren = codegenCodegenRoute._addFileChildren(
  codegenCodegenRouteChildren,
)

interface pavilionPavilionRouteChildren {
  pavilionPavilionAgentNameRoute: typeof pavilionPavilionAgentNameRoute
  pavilionPavilionNewRoute: typeof pavilionPavilionNewRoute
  pavilionPavilionIndexRoute: typeof pavilionPavilionIndexRoute
}

const pavilionPavilionRouteChildren: pavilionPavilionRouteChildren = {
  pavilionPavilionAgentNameRoute: pavilionPavilionAgentNameRoute,
  pavilionPavilionNewRoute: pavilionPavilionNewRoute,
  pavilionPavilionIndexRoute: pavilionPavilionIndexRoute,
}

const pavilionPavilionRouteWithChildren =
  pavilionPavilionRoute._addFileChildren(pavilionPavilionRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  authAuthRoute: authAuthRouteWithChildren,
  authWaitinglistRoute: authWaitinglistRouteWithChildren,
  codegenCodegenRoute: codegenCodegenRouteWithChildren,
  pavilionPavilionRoute: pavilionPavilionRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
